import { space, colors } from "utils/theme";
import styled from "styled-components";

const Doc = styled.div`
  *:has(> table) {
    table {
      // max-width: 100%;
      overflow-x: auto;
    }
  }
  *:has(> iframe[align="middle"]) {
    text-align: center;
  }
  .doc {
    &, &;* {
      font-family: ${(props) =>
        props?.ltr
          ? '"Roboto", sans-serif;'
          : "'IRANSans_FaNum', Tahoma;"}
    }    
    &.dot {
      @media (min-width: 744px) {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 14;
        -webkit-box-orient: vertical;
        img {
          display: none;
        }
      }
    }

    p,
    span {
      background-color: unset !important;
    }
    img {
      max-width: 100% !important;
      @media (max-width: 744px) {
        height: auto !important;
      }
    }
    li[style*="text-align: left;"],
    li[style*="text-align:left;"],
    li[style*="text-align:left"] {
      direction: ltr;
    }
    li {
      list-style-position: ${(props) =>
        props.insideList === false ? "unset" : "inside"};
    }
    figure {
      width: 100% !important;
      &:has(> table) {
        max-width: 100%;
        overflow-x: auto;
      }
    }
    
    figure {
      // width: 100% !important;
    }
    figure.table {
      width: 100% !important;
      max-width: 100%;
      overflow-x: auto;
    }
    table {
      width: 100%;
      text-align: center;
      border-spacing: 0;
      th {
        font-size: 0.9rem;
        font-weight: 500;
        padding-top: ${space(1.5)};
        padding-bottom: ${space(1.5)};
        // border-left: 1px solid ${colors.primary.lighter};
        // &:first-child {
        //   border-right: 1px solid ${colors.primary.lighter};
        // }
      }
      td {
        font-size: 1rem;
        font-weight: 300;
        padding-top: ${space(1)};
        padding-bottom: ${space(1)};
        // border-left: 1px solid ${colors.primary.lighter};
        // &:first-child {
        //   border-right: 1px solid ${colors.primary.lighter};
        // }
      }
      // tr {
      //   &:nth-child(odd) {
      //     td {
      //       background: ${colors.primary.lightest};
      //     }
      //   }
      //   &:last-child {
      //     td {
      //       border-bottom: 1px solid ${colors.primary.lighter};
      //     }
      //   }
      //   &.section-title {
      //     td {
      //       background: ${colors.grey[7]};
      //       font-weight: 500;
      //       font-size: 0.9rem;
      //     }
      //   }
      // }
    }
    
    table[align="center"] {
      margin-right: auto;
      margin-left: auto;
    }
  }
`;

export default Doc;
